import { ModalTemplateData } from "@/shared/components/ModalTemplate/models/ModalTemplateData";
import { ActionData } from "../models/ActionData";
import { STATE } from "@/shared/constants/GeneralConstants";

export const CONTEXTUAL_ELEMENTS = {
  INFO_GROUPS: "infoGroupData",
  FORM_TEMPLATES: "formTemplatesData"
};

export const DATA_DEFAULT: {
  MODAL: ModalTemplateData;
  ACTION_DATA: ActionData;
} = {
  MODAL: {
    id: "",
    actived: false,
    title: "",
    text: "",
    textAccept: ""
  },
  ACTION_DATA: { id: "", operation: "", state: STATE.ACTIVE }
};
